import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSession } from "../../authentications/SessionContext";

function RouteTracker() {
  const location = useLocation();
  const { setSearchQuery } = useSession();

  useEffect(() => {
    // Save the current route to localStorage when navigating
    // if (location.pathname?.includes('homepage'))
    localStorage.setItem("lastVisitedRoute", location.pathname);
    setSearchQuery("");
    // console.log("saved route", location.pathname);
  }, [location.pathname]);

  return null;
}

export default RouteTracker;
